import { useParams } from 'react-router-dom';
import { throw404 } from '@/helpers/throw404';

/** Required positive integer IDs fail at the route boundary before fetching. */
export function useRequiredRouteId(parameter: string): number {
  const parameters = useParams();
  const id = Number(parameters[parameter]);

  if (!Number.isSafeInteger(id) || id <= 0) throw404();

  return id;
}
